module.exports = __webpack_public_path__ + "img/2.85d5a4e8.jpg";